const getters = {
  sidebar: state => state.app.sidebar,
  device: state => state.app.device,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  userid: state => state.user.id,
  name: state => state.user.name,
  isAdmin: state => state.user.isAdmin,
}
export default getters
